import React from 'react';
import Select from './select/Select';
import { getTimezoneOptions, TimezoneBaseOption } from '../util/timezone';
import Flex from './Flex';
import Text from './Text';

interface Props {
  value: string;
  labelId: string;
  onChange: (value: string) => void;
}

function OptionFormatter({ option }: { option: TimezoneBaseOption }) {
  return (
    <Flex gap={1} justifyContent="space-between" alignItems="center">
      <Text>{option.label}</Text>
      <Text muted small>
        <Text fontWeight={600}>{option.alias}</Text> {option.offset}
      </Text>
    </Flex>
  );
}

function valueRenderer(option: TimezoneBaseOption, placeholder: string) {
  if (!option) {
    return <Text muted>{placeholder || 'Select a timezone...'}</Text>;
  }

  return <OptionFormatter option={option} />;
}

export default function TimezoneSelect({ value, labelId, onChange }: Props) {
  const options = getTimezoneOptions();

  return (
    <Select
      labelId={labelId}
      values={value}
      onChange={onChange}
      options={options}
      optionFormatter={OptionFormatter}
      valueRenderer={valueRenderer}
      responsive
      menuWidth="auto"
      showFilter
    />
  );
}
